import { Component, inject } from '@angular/core';

import { Router, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HeaderComponent  } from './header/header.component';
import { environment } from '../environments/environment';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { RightComponent } from './right/right.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    RightComponent,
    RouterLinkActive
],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DHR Portal';
  router: Router = inject(Router);
  ngOnInit(): void {
    console.log('*** Environment ***');
    console.log(JSON.stringify(environment, null, 4));
  }
}
